<script lang="ts">
  import { Subscriptions } from "@packages/ui";
  import {
    cancelSubscription,
    getUserSubscriptions,
    normalizeSubscriptionsResponse,
  } from "@packages/utils/lib/subscriptions";
  import { configStore } from "@src/stores";

  const loadSubscriptions = async () => {
    const response = await getUserSubscriptions($configStore.credenza.generalApiUrl, {
      limit: 50,
      offset: 0,
      sort_by: "created_at",
      order: "desc",
    });

    return normalizeSubscriptionsResponse(response);
  };
</script>

<Subscriptions
  {loadSubscriptions}
  cancelSubscription={(id) => cancelSubscription($configStore.credenza.generalApiUrl, id)}
/>

